import { combineReducers } from '@reduxjs/toolkit'
import travelDetailsSlice from './slices/visaSlice/travelDetailsSlice'
import animationSlice from './slices/animaitionSlice'
import visaRequirementsSlice from './slices/visaSlice/visaRequirementsSlice'
import visaErrorSlice from './slices/visaSlice/visaErrorSlice'
import itineraryInfoSlice from './slices/visaSlice/itineraryInfoSlice'
import visaBookingListSlice from './slices/visaSlice/visaBookingListSlice'
import documentsSlice from './slices/visaSlice/documentSlice'
import dashboardBookingSlice from './slices/visaSlice/dashboardBookingSlice'
import notificationSlice from './slices/notificationSlice'
import visaPayConfirmSlice from './slices/visaSlice/visaConfirmationSlice'
import errorHandlingReducer from './slices/errorHandlingSlice'
import userProfileSlice from './slices/visaSlice/userProfileSlice'

const createReducer = (injectedReducers = {}) =>
    combineReducers({
        travelDetails: travelDetailsSlice,
        animation: animationSlice,
        visaRequirements: visaRequirementsSlice,
        visaError: visaErrorSlice,
        itineraryInfo: itineraryInfoSlice,
        visaBookingList: visaBookingListSlice,
        visaPayDetails: visaPayConfirmSlice,
        documents: documentsSlice,
        dashboardBooking: dashboardBookingSlice,
        errorHandling: errorHandlingReducer,
        notification: notificationSlice,
        userProfile: userProfileSlice,
        ...injectedReducers
    })

export default createReducer()
